module.exports = __webpack_public_path__ + "img/kefu_bg.02287717.png";